import { render, staticRenderFns } from "./ProveedoresComponent.vue?vue&type=template&id=13bc2064&"
import script from "./ProveedoresComponent.vue?vue&type=script&lang=js&"
export * from "./ProveedoresComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports